<template>
    <!-- <router-view baseADMIN="https://50955705admin.qhr.app/" baseAPI="https://50955705erp.qhr.app" baseLINE="https://50955705linebot.qhr.app/" baseURL="https://50955705punch.qhr.app/" v-on:menuShow="menuShow"/> -->
    <!-- <router-view baseADMIN="https://56623731admin.qhr.app" baseAPI="https://56623731erp.qhr.app" baseLINE="https://56623731linebot.qhr.app" baseURL="https://56623731punch.qhr.app" v-on:menuShow="menuShow"/> -->

    <!-- <router-view baseADMIN="http://114.35.38.159:1201" baseAPI="http://114.35.38.159:9527" baseLINE="https://test.qsystem.com.tw" baseURL="https://testpunchin.qsystem.com.tw" v-on:menuShow="menuShow"/> -->
    <!-- <router-view baseADMIN="http://114.35.38.159:9527" baseAPI="http://114.35.38.159:1202" baseLINE="https://test.qsystem.com.tw" baseURL="https://testpunchin.qsystem.com.tw" v-on:menuShow="menuShow"/> -->
    <router-view :tax="$route.params.tax" :baseADMIN="'https://admin.qhr.app/'+$route.params.tax" :baseAPI="'https://erp.qhr.app/'+$route.params.tax" :baseLINE="'https://test.linebot.qhr.app/'+$route.params.tax " :baseURL="'https://test.punch.qhr.app/'+$route.params.tax" v-on:menuShow="menuShow"/>
    <!-- <router-view baseADMIN="https://12994073admin.qhr.app" baseAPI="https://12994073erp.qhr.app" baseLINE="https://12994073linebot.qhr.app" baseURL="https://12994073punch.qhr.app" v-on:menuShow="menuShow"/> -->
    <!-- <router-view baseADMIN="https://80125262admin.qhr.app" baseAPI="https://80125262erp.qhr.app" baseLINE="https://80125262linebot.qhr.app" baseURL="https://80125262punch.qhr.app" v-on:menuShow="menuShow"/> -->
    <!-- <router-view baseADMIN="https://admin.qhr.app" baseAPI="https://erp.qhr.app" baseLINE="https://test.linebot.qhr.app" baseURL="https://test.punch.qhr.app" v-on:menuShow="menuShow"/> -->
</template>

<script>
export default {
    props: ['baseURL','baseLINE','baseAPI','baseADMIN','tax'],
    methods:{
        menuShow: function (data) {
        console.log("子",data);
            // childValue就是子组件传过来的值
            if(data == false){
            this.ctrlCls = "d-none";
            }
        }
    },
}
</script>